<template>
  <div class="container py-2" dir="rtl" id="printableArea">
    <div class="row my-2 Printed">
      <div class="col-md-2 col-12 p-0"><img src="/assets/pics/Logo.png" alt="Logo" style="max-width: 15vw !important" /></div>
      <div class="col-md-8 text-center font-weight-bold" style="font-size: 1.8rem !important">
        {{ Header }}
      </div>
      <div class="col-md-2 col-12"></div>
    </div>
    <div class="row mb-2 mt-2">
      <div class="col-md-3 col-12">
        <span class="no-print bg-warning py-1 px-3 mb-2 Pointer" @click="printPageArea" v-if="$route.name == 'Print'">چاپ گزارش</span>
      </div>
      <div class="col-md-3 col-12"></div>
      <div class="col-md-3 col-12">
        کاربر گزارش گیرنده : <span class="font-weight-bold">{{ $session.get('UserInfo').namFam }}</span>
      </div>
      <div class="col-md-3 col-12" dir="rtl">
        تاریخ گزارش : <span class="font-weight-bold">{{ $GetJalaliDateTime() }}</span>
      </div>
    </div>
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th v-for="(c, indexc) in MainRows" :key="indexc" scope="col">{{ c.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(r, indexr) in Rows" :key="indexr">
          <td v-for="(c, indexcc) in MainRows" :key="indexcc">
            <span v-if="c.name == 'row'"> {{ indexr + 1 }}</span>

            <!-- <span v-for="(lc, indexlc) in ListCommaReport" :key="indexlc"> -->
            <span v-if="ListCommaReport.indexOf(c.name) >= 0"> {{ $Comma3ragham(r[c.name]) }}</span>
            <span v-else> {{ r[c.name] }}</span>
            <!-- </span> -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      MainRows: [],
    }
  },
  props: ['Columns', 'Rows', 'hasRowNum', 'Header', 'ListCommaReport'],
  mounted() {
    if (this.hasRowNum) {
      this.MainRows.push({ id: 555, name: 'row', visibility: true, width: 329, indexCol: 1, label: '#' })
    }
    for (let index = 0; index < this.Columns.length; index++) {
      this.MainRows.push(this.Columns[index])
    }
  },
  methods: {
    printPageArea() {
      var mywindow = window.open('', 'PRINT')

      mywindow.document.write('<html><head>')
      mywindow.document.write('<link rel="stylesheet" href="/assets/bootstrap/bootstrap.min.css"  >')
      mywindow.document.write('<link rel="stylesheet" href="/assets/iransans/font-face-Sans.css">')
      mywindow.document.write('<link rel="stylesheet" href="/assets/print/style.css">')
      mywindow.document.write('</head><body onload="window.print()" dir="rtl">')
      mywindow.document.write(document.getElementById('printableArea').innerHTML)
      mywindow.document.write('</body></html>')
      mywindow.document.close()

      mywindow.focus()

      // mywindow.print();
      // mywindow.close();
      return true
    },
    print() {
      style.type = 'text/css'
      style.media = 'print'

      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }

      head.appendChild(style)

      window.print()
    },
  },
}
</script>
<style scoped>
tr th,
td {
  text-align: center;
}
thead {
  background: #c7c7c7;
}
.Printed {
  page-break-inside: avoid !important;
}
</style>
